import React, { useState } from 'react'
import FrameImpact from '../../../shared/assets/frame-impact.png'
import { getInitials } from '../HeaderBlock'
import LogoWhite from '../../../../../assets/svg/logo-white.svg'
import CO2Export from '../../../shared/assets/co2-export.png'
import SolarExport from '../../../shared/assets/solar-export.png'
import { Markup } from 'interweave'
import html2canvas from 'html2canvas'
import config from '../../../../../config'
import { sendTelegramMessage } from '../../../../../utils/api'

interface ImpactBlockProps {
  name?: string;
  profileId?: string;
  totalCo2: number;
}

const ImpactBlock: React.FC<ImpactBlockProps> = ({
  name,
  profileId = '',
  totalCo2 = 0,
}) => {
  const componentRef = React.useRef<HTMLDivElement | null>(null)
  const [showToast, setShowToast] = useState(false)
  const handleDownloadImage = async () => {
    // Check if the current ref is not null
    if (componentRef.current !== null) {
      const canvas = await html2canvas(componentRef.current)
      const image = canvas.toDataURL('image/png')
      const link = document.createElement('a')
      link.href = image
      link.download = `Pyrpose_${name}.png`
      link.click()
    }
  }

  const protocol = config.apiEndpoint?.includes('localhost') ? 'http' : 'https'
  const shareUrl = `${protocol}://${config.inviteUrl}/from/${profileId}`

  const handleCopy = async() => {

    navigator.clipboard.writeText(shareUrl)
      .then(async() => {
        await sendTelegramMessage({ text: `${name} copied share link ` })
        setShowToast(true)
        setTimeout(() => {
          setShowToast(false)
        }, 3000)
      })
      .catch(err => {
        console.error('Failed to copy: ', err)
      })
  }

  const initials = getInitials(name || '')


  return (
    <div className=' flex items-center justify-center gap-6  py-[100px] w-full max-w-[100vw]'>
      {showToast &&
        <div
          className='w-full max-w-[608px] px-8 py-4 h-[70px] bg-green-200 animated animate__fadeIn animate__animated fixed bottom-[100px] mx-auto left-4 right-4 z-[10000] rounded-xl shadow border border-neutral-400 justify-center items-center gap-3 inline-flex'>
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z'
              stroke='#37992E' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
          <div className="text-green-600 text-[17px] font-medium font-['Inter'] text-start leading-normal">The link has
            been copied
          </div>
        </div>
      }
      <div className={'flex-col justify-start items-start px-4  flex max-w-[1200px]'}>
        <div className='flex-col justify-center items-center gap-2 flex w-full max-w-[100%]'>
          <div className={'w-full flex flex-row justify-center items-center'}>
            <div
              className=' text-green-600 text-[12px] font-bold uppercase'
            >impact
            </div>
          </div>
          <div className={' flex-col flex items-center justify-center pb-[16px] w-full'}>
            <div className='max-sm:w-full text-start text-[28px] font-semibold' style={{
              fontFamily: 'Inter',
            }}>Your climate and social impact
            </div>
            <Markup className={'text-[17px] leading-[24px]  '}
                    content={'Your Pyrpose investment is offsetting greenhouse gas emissions <br/> by an amount equivalent to'} />
          </div>
        </div>
        <div
          className={'w-[722px] max-w-[722px] h-[602px]'}
          ref={componentRef}
          style={{
            backgroundImage: `url(${FrameImpact})`,
            backgroundRepeat: 'none',
            backgroundSize: 'contain',
          }}
        >
          <div className={'flex flex-col h-full w-full p-8 gap-3'}>
            <div className={'h-[60%] w-full gap-3 flex flex-row'}>
              <div className={'w-[40%] flex flex-col gap-3'}>
                <div className={'w-full h-[70%] py-8 px-6 flex flex-col bg-[#0C4725] rounded-[16px]'}>
                  <div className={'flex flex-row gap-2 items-center '}>
                    <div
                      className={'w-10 h-10  bg-green-200 hover:bg-[#83F279] flex items-center justify-center relative cursor-pointer rounded-[40px] '}>
                      <div
                        className='text-green-800 text-[17px] font-medium font-Inter '>{initials}</div>
                    </div>
                    <div className={'text-[17px] font-[500] text-white font-Inter leading-[20px]'}>
                      {name}
                    </div>
                  </div>
                  <div className={'text-[18px] leading-[24px] font-semibold font-Inter text-[#83F279] text-start pt-3'}>
                    I`ve invested in a company that reduces carbon emissions and you can too!
                  </div>
                </div>
                <div
                  className={'w-full h-[30%] py-4 px-6 flex flex-row gap-4 items-center bg-[#A6ED9F] rounded-[16px]'}>
                  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <rect width='64' height='64' rx='32' fill='#E1F7DC' />
                    <path d='M32 23V51.5H38' stroke='#06401A' strokeWidth='3' strokeLinecap='round' />
                    <path d='M32 38L26.75 34.25' stroke='#06401A' strokeWidth='3' strokeLinecap='round' />
                    <path d='M32 51.5H26' stroke='#06401A' strokeWidth='3' strokeLinecap='round' />
                    <path d='M32 30.5L37.25 26.75' stroke='#06401A' strokeWidth='3' strokeLinecap='round' />
                    <path
                      d='M32 11C24.5 11 18.5 24.5 18.5 32C18.5 39.5 24.5442 44 32 44C39.4558 44 45.5 39.5 45.5 32C45.5 24.5 39.5 11 32 11Z'
                      stroke='#06401A' strokeWidth='3' />
                  </svg>
                  <div className={'text-[20px] leading-[28px] text-[#06401A] font-Inter font-semibold text-start'}>
                    {/* {(totalCo2 / 0.01).toFixed(2)} trees planted */}1M trees planted
                  </div>
                </div>
              </div>
              <div className={'w-[60%] flex flex-col gap-3'}>
                <div className={'w-full h-[30%] flex flex-col items-center justify-center bg-[#0C4725] rounded-[16px]'}>
                  <img src={LogoWhite} alt='logo' className={'pb-[-20px]'} />
                </div>
                <div className={'w-full h-[70%] flex flex-row gap-4 relative items-center bg-[#A6ED9F] rounded-[16px]'}
                     style={{
                       backgroundImage: `url(${CO2Export})`,
                       backgroundRepeat: 'none',
                       backgroundSize: 'cover',
                     }}>
                  <div
                    className={'absolute top-6 bottom-6 right-6 left-6 flex flex-col justify-between items-start'}>
                    <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
                      <rect width='64' height='64' rx='32' fill='white' />
                      <path
                        d='M26.75 47C18.0515 47 11 39.8366 11 31C11 22.1634 18.0515 15 26.75 15C32.8036 15 38.0596 18.4695 40.6962 23.5579C40.9454 23.5416 41.1967 23.5333 41.45 23.5333C47.8289 23.5333 53 28.7865 53 35.2667C53 41.7468 47.8289 47 41.45 47C36.0918 47 32.257 47 26.75 47Z'
                        fill='#3EC731' />
                      <path
                        d='M40.7188 39.4587V38.4019L42.737 36.7474C43.4906 36.1238 43.7851 35.7946 43.7851 35.2922C43.7851 34.7812 43.4473 34.504 42.9709 34.504C42.5031 34.504 42.1826 34.7638 41.7322 35.3182L40.7967 34.5646C41.3944 33.7504 41.9748 33.3086 43.0575 33.3086C44.3135 33.3086 45.1451 34.0449 45.1451 35.1969C45.1451 36.2104 44.6254 36.7128 43.5513 37.5444L42.5638 38.3066H45.2057V39.4587H40.7188Z'
                        fill='white' stroke='white' strokeWidth='0.2' />
                      <path
                        d='M34.2948 38.1886C31.1909 38.1886 29.0254 35.8354 29.0254 32.9625C29.0254 30.1184 31.2198 27.7363 34.3237 27.7363C37.4276 27.7363 39.5932 30.0895 39.5932 32.9625C39.5932 35.8065 37.3988 38.1886 34.2948 38.1886ZM34.3237 36.5572C36.3304 36.5572 37.7308 34.9547 37.7308 32.9625C37.7308 30.9991 36.3016 29.3677 34.2948 29.3677C32.2881 29.3677 30.8877 30.9702 30.8877 32.9625C30.8877 34.9259 32.317 36.5572 34.3237 36.5572Z'
                        fill='white' stroke='white' strokeWidth='0.2' />
                      <path
                        d='M23.9325 38.1886C20.9874 38.1886 18.793 35.8931 18.793 32.9625C18.793 30.0895 20.9441 27.7363 24.0047 27.7363C25.867 27.7363 26.9931 28.386 27.9604 29.3099L26.8198 30.6237C26.0114 29.873 25.1452 29.3677 23.9902 29.3677C22.0557 29.3677 20.6553 30.9557 20.6553 32.9625C20.6553 34.9403 22.0557 36.5572 23.9902 36.5572C25.2318 36.5572 26.0258 36.0519 26.892 35.2435L28.0325 36.3984C26.9787 37.4956 25.8237 38.1886 23.9325 38.1886Z'
                        fill='white' stroke='white' strokeWidth='0.2' />
                    </svg>
                    <div className={'text-[28px] w-1/2 leading-[32px] text-start font-semibold font-Inter text-white'}>
                      {/* {totalCo2} t of CO2 reduced */}10,000 t of C02 reduced
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={'h-[40%] w-full gap-3 flex flex-row'}>
              <div className={'w-[60%] flex flex-col relative gap-3 bg-[#0C4725] rounded-[16px] h-full'}
                   style={{
                     backgroundImage: `url(${SolarExport})`,
                     backgroundRepeat: 'none',
                     backgroundSize: 'cover',
                   }}>
                <div
                  className={'absolute top-6 bottom-6 right-6 left-6 flex flex-col justify-between items-start'}>
                  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <rect width='64' height='64' rx='32' fill='white' />
                    <path
                      d='M33.9997 12L16.1866 33.3757C15.489 34.2128 15.1402 34.6314 15.1349 34.9849C15.1302 35.2922 15.2672 35.5846 15.5062 35.7778C15.7812 36 16.3261 36 17.4158 36H31.9997L29.9997 52L47.8128 30.6243C48.5104 29.7872 48.8592 29.3686 48.8646 29.0151C48.8692 28.7078 48.7323 28.4154 48.4932 28.2222C48.2182 28 47.6734 28 46.5837 28H31.9997L33.9997 12Z'
                      fill='#3EC731' />
                  </svg>
                  <div className={'text-[28px] w-2/3 leading-[32px] text-start font-semibold font-Inter text-white'}>
                    16,000 kWh of energy created
                  </div>
                </div>
              </div>
              <div className={'w-[40%] flex flex-col gap-3'}>
                <div
                  className={'w-full h-[50%] py-4 px-6 flex flex-row gap-4 items-center bg-[#A6ED9F] rounded-[16px]'}>
                  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <rect width='64' height='64' rx='32' fill='#E1F7DC' />
                    <path
                      d='M27.999 43.3191V48.002C27.999 50.2111 29.7899 52.002 31.999 52.002C34.2082 52.002 35.999 50.2111 35.999 48.0019V43.3191M31.999 12.002V14.002M13.999 32.002H11.999M18.999 19.002L17.7988 17.8018M44.999 19.002L46.1995 17.8018M51.999 32.002H49.999M43.999 32.002C43.999 38.6294 38.6264 44.002 31.999 44.002C25.3716 44.002 19.999 38.6294 19.999 32.002C19.999 25.3745 25.3716 20.002 31.999 20.002C38.6264 20.002 43.999 25.3745 43.999 32.002Z'
                      stroke='#06401A' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                  <div className={'text-[20px] leading-[28px] text-[#06401A] font-Inter font-semibold text-start'}>
                    {/* {(totalCo2 / 0.11).toFixed(2)} bulbs lit for 1 year */}90,9K bulbs lit for 1 year
                  </div>
                </div>
                <div
                  className={'w-full h-[50%] py-4 px-6 flex flex-row gap-4 items-center bg-[#A6ED9F] rounded-[16px]'}>
                  <svg width='64' height='64' viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <rect width='64' height='64' rx='32' fill='#E1F7DC' />
                    <path
                      d='M41.616 16.0732C43.3847 14.2464 46.3071 14.2227 48.1051 16.0208C49.8539 17.7695 49.8864 20.5946 48.1784 22.3832L43.0842 27.7178C42.6849 28.1359 42.4853 28.345 42.3623 28.5899C42.2533 28.8066 42.1885 29.0429 42.1716 29.2848C42.1524 29.5582 42.2174 29.8399 42.3474 30.4032L45.5152 44.1304C45.6487 44.7087 45.7154 44.9978 45.6939 45.2775C45.6748 45.525 45.6057 45.7661 45.4906 45.9861C45.3607 46.2347 45.1508 46.4445 44.7312 46.8642L44.0515 47.5439C42.9402 48.6552 42.3846 49.2108 41.8159 49.3114C41.3193 49.3992 40.8085 49.2787 40.4036 48.978C39.9399 48.6337 39.6914 47.8883 39.1945 46.3973L35.5099 35.3437L29.3768 41.4768C29.0107 41.8429 28.8277 42.0259 28.7052 42.2415C28.5968 42.4324 28.5235 42.6413 28.4889 42.8582C28.4499 43.103 28.4784 43.3603 28.5356 43.8749L28.8724 46.9061C28.9296 47.4207 28.9582 47.6779 28.9191 47.9228C28.8845 48.1396 28.8113 48.3485 28.7028 48.5395C28.5803 48.7551 28.3973 48.9381 28.0312 49.3042L27.6691 49.6663C26.8018 50.5336 26.3682 50.9672 25.8863 51.0928C25.4636 51.2029 25.0155 51.1586 24.6227 50.9677C24.1748 50.75 23.8346 50.2398 23.1542 49.2192L20.279 44.9063C20.1574 44.724 20.0967 44.6329 20.0261 44.5502C19.9634 44.4767 19.895 44.4083 19.8216 44.3457C19.7389 44.2751 19.6478 44.2143 19.4654 44.0928L15.1525 41.2175C14.132 40.5372 13.6218 40.197 13.4041 39.7491C13.2132 39.3562 13.1688 38.9081 13.279 38.4855C13.4046 38.0036 13.8382 37.5699 14.7055 36.7027L15.0676 36.3406C15.4337 35.9745 15.6167 35.7914 15.8323 35.669C16.0232 35.5605 16.2321 35.4872 16.449 35.4526C16.6938 35.4136 16.9511 35.4422 17.4657 35.4994L20.4969 35.8362C21.0115 35.8933 21.2687 35.9219 21.5136 35.8829C21.7304 35.8483 21.9393 35.775 22.1303 35.6665C22.3459 35.5441 22.5289 35.361 22.895 34.995L29.0281 28.8619L17.9744 25.1773C16.4835 24.6803 15.738 24.4318 15.3938 23.9682C15.0931 23.5633 14.9725 23.0525 15.0604 22.5559C15.1609 21.9872 15.7166 21.4316 16.8278 20.3203L17.5076 19.6406C17.9272 19.2209 18.1371 19.0111 18.3856 18.8811C18.6057 18.7661 18.8467 18.697 19.0943 18.6779C19.374 18.6564 19.6631 18.7231 20.2414 18.8565L33.9164 22.0123C34.4847 22.1435 34.7688 22.209 35.0431 22.1895C35.308 22.1707 35.5656 22.0945 35.7981 21.9664C36.039 21.8336 36.2418 21.6241 36.6474 21.2051L41.616 16.0732Z'
                      stroke='#06401A' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
                  </svg>
                  <div className={'text-[20px] leading-[28px] text-[#06401A] font-Inter font-semibold text-start'}>
                    {/* {(totalCo2 / 1.05).toFixed(2)} flights Paris — NY */} 9.5K flights Paris — NY
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={' flex-col flex items-center justify-center pt-8 w-full'}>
          <Markup className={'text-[17px] leading-[24px]  '}
                  content={'Do you want to make more impact?  <br/> Invite your friends and invest in climate together:'} />
          <div className={'items-center mt-8 flex flex-row gap-8 cursor-pointer w-full justify-between'}>
            <div className={'py-3 border-[1px] w-[60%] rounded-[12px] flex flex-col'}>
              <div className={'font-Inter text-[15px] text-center mb-3'}>
                1. Copy a sharing link or download the image
              </div>
              <div className={'flex flex-row gap-4 w-full justify-center'}>
                <div onClick={handleCopy}
                     className={'px-[20px] py-[14px] bg-[#00000008] rounded-[8px] flex flex-row gap-2 items-center justify-center cursor-pointer'}>
                  <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path fillRule='evenodd' clipRule='evenodd'
                          d='M14.0063 6.49395C14.3317 6.81939 14.3317 7.34702 14.0063 7.67246L8.17297 13.5058C7.84753 13.8312 7.31989 13.8312 6.99446 13.5058C6.66902 13.1804 6.66902 12.6527 6.99446 12.3273L12.8278 6.49395C13.1532 6.16851 13.6809 6.16851 14.0063 6.49395Z'
                          fill='#0F0F0F' />
                    <path fillRule='evenodd' clipRule='evenodd'
                          d='M5.78633 8.82138C6.11177 9.14682 6.11177 9.67445 5.78633 9.99989L4.60782 11.1784C3.30607 12.4802 3.30607 14.5907 4.60782 15.8924C5.90957 17.1942 8.02012 17.1942 9.32187 15.8924L10.5004 14.7139C10.8258 14.3885 11.3535 14.3885 11.6789 14.7139C12.0043 15.0394 12.0043 15.567 11.6789 15.8924L10.5004 17.071C8.54776 19.0236 5.38193 19.0236 3.42931 17.071C1.47669 15.1183 1.47669 11.9525 3.42931 9.99989L4.60782 8.82138C4.93326 8.49594 5.4609 8.49594 5.78633 8.82138Z'
                          fill='#0F0F0F' />
                    <path fillRule='evenodd' clipRule='evenodd'
                          d='M10.5004 2.92882C12.453 0.9762 15.6188 0.9762 17.5714 2.92882C19.5241 4.88144 19.5241 8.04727 17.5714 9.99989L16.3929 11.1784C16.0675 11.5038 15.5399 11.5038 15.2144 11.1784C14.889 10.853 14.889 10.3253 15.2144 9.99989L16.3929 8.82138C17.6947 7.51963 17.6947 5.40908 16.3929 4.10733C15.0912 2.80559 12.9806 2.80559 11.6789 4.10733L10.5004 5.28584C10.1749 5.61128 9.6473 5.61128 9.32187 5.28584C8.99643 4.96041 8.99643 4.43277 9.32187 4.10733L10.5004 2.92882Z'
                          fill='#0F0F0F' />
                  </svg>

                  <div className={'text-[#0F0F0F] font-Inter text-[17px]'}>
                    Copy link
                  </div>
                </div>
                <div onClick={handleDownloadImage}
                     className={'px-[20px] py-[14px] bg-[#00000008] rounded-[8px] flex flex-row gap-2 items-center justify-center cursor-pointer'}>
                  <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                    <path
                      d='M11.3337 2.49984C11.3337 2.0396 10.9606 1.6665 10.5003 1.6665C10.0401 1.6665 9.66699 2.0396 9.66699 2.49984V10.488L6.92291 7.74392C6.59748 7.41848 6.06984 7.41848 5.7444 7.74392C5.41897 8.06935 5.41897 8.59699 5.7444 8.92243L9.91107 13.0891C10.2365 13.4145 10.7641 13.4145 11.0896 13.0891L15.2562 8.92243C15.5817 8.59699 15.5817 8.06935 15.2562 7.74392C14.9308 7.41848 14.4032 7.41848 14.0777 7.74392L11.3337 10.488V2.49984Z'
                      fill='#0F0F0F' />
                    <path
                      d='M3.00033 11.6665C3.46056 11.6665 3.83366 12.0396 3.83366 12.4998V13.4998C3.83366 14.2137 3.83431 14.6989 3.86495 15.074C3.8948 15.4393 3.94891 15.6262 4.01532 15.7565C4.1751 16.0701 4.43007 16.3251 4.74368 16.4848C4.87401 16.5513 5.06085 16.6054 5.42619 16.6352C5.80127 16.6659 6.28651 16.6665 7.00033 16.6665H14.0003C14.7141 16.6665 15.1994 16.6659 15.5745 16.6352C15.9398 16.6054 16.1266 16.5513 16.257 16.4848C16.5706 16.3251 16.8255 16.0701 16.9853 15.7565C17.0517 15.6262 17.1058 15.4393 17.1357 15.074C17.1663 14.6989 17.167 14.2137 17.167 13.4998V12.4998C17.167 12.0396 17.5401 11.6665 18.0003 11.6665C18.4606 11.6665 18.8337 12.0396 18.8337 12.4998V13.5343C18.8337 14.2051 18.8337 14.7587 18.7968 15.2097C18.7586 15.6781 18.6764 16.1087 18.4703 16.5131C18.1508 17.1403 17.6408 17.6503 17.0136 17.9699C16.6092 18.1759 16.1786 18.2581 15.7102 18.2963C15.2592 18.3332 14.7056 18.3332 14.0347 18.3332H6.96591C6.2951 18.3332 5.74147 18.3332 5.29047 18.2963C4.82206 18.2581 4.39147 18.1759 3.98703 17.9699C3.35982 17.6503 2.84988 17.1403 2.5303 16.5131C2.32423 16.1087 2.24209 15.6781 2.20382 15.2097C2.16697 14.7587 2.16698 14.2051 2.16699 13.5343V12.4998C2.16699 12.0396 2.54009 11.6665 3.00033 11.6665Z'
                      fill='#0F0F0F' />
                  </svg>
                  <div className={'text-[#0F0F0F] font-Inter text-[17px]'}>
                    Download image
                  </div>
                </div>
              </div>
            </div>
            <div className={'py-3 border-[1px] w-[40%] rounded-[12px] flex flex-col items-center  '}>
              <div className={'font-Inter text-[15px] text-center mb-3'}>
                2. Subscribe to our LinkedIn profile
              </div>
              <a
                className={'px-[20px] py-[14px] bg-black rounded-[8px] flex flex-row gap-2 items-center justify-center'}
                href={'https://www.linkedin.com/company/pyrpose/'} target={'_blank'} rel='noreferrer'>
                <svg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <g clipPath='url(#clip0_5098_1495)'>
                    <path
                      d='M19.0195 0H1.97656C1.16016 0 0.5 0.644531 0.5 1.44141V18.5547C0.5 19.3516 1.16016 20 1.97656 20H19.0195C19.8359 20 20.5 19.3516 20.5 18.5586V1.44141C20.5 0.644531 19.8359 0 19.0195 0ZM6.43359 17.043H3.46484V7.49609H6.43359V17.043ZM4.94922 6.19531C3.99609 6.19531 3.22656 5.42578 3.22656 4.47656C3.22656 3.52734 3.99609 2.75781 4.94922 2.75781C5.89844 2.75781 6.66797 3.52734 6.66797 4.47656C6.66797 5.42188 5.89844 6.19531 4.94922 6.19531ZM17.543 17.043H14.5781V12.4023C14.5781 11.2969 14.5586 9.87109 13.0352 9.87109C11.4922 9.87109 11.2578 11.0781 11.2578 12.3242V17.043H8.29688V7.49609H11.1406V8.80078H11.1797C11.5742 8.05078 12.543 7.25781 13.9844 7.25781C16.9883 7.25781 17.543 9.23438 17.543 11.8047V17.043Z'
                      fill='#F2F2EF' />
                  </g>
                  <defs>
                    <clipPath id='clip0_5098_1495'>
                      <rect width='20' height='20' fill='white' transform='translate(0.5)' />
                    </clipPath>
                  </defs>
                </svg>
                <div className={'text-white font-Inter text-[17px]'}>
                  LinkedIn
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ImpactBlock